import { graphql } from '../gql';

export const GET_ALL_REFERRAL_CODES = graphql(`
  query GetAllReferralCodes($token: String!) {
    getAllReferralCodes(token: $token) {
      id
      code
      description
      quotes {
        uniqueID
        friendlyId
        dateAdded
        structuredData {
          businessName
          contactName
        }
      }
    }
  }
`);
